import React, {Component} from 'react';
import { renderToStaticMarkup } from 'react-dom/server';
import {connect} from "react-redux";
import {Header, Button, Modal, Form, Table} from 'semantic-ui-react';
import { jsPDF } from "jspdf";

import RecipeStockData from "../../data/RecipeStockData";
import {openModalProductStockUpdate} from "../../actions/ModalProductStockUpdateActions";
import {updateRecipeStock} from "../../actions/RecipeStockActions";
import {showToast} from "../../actions/ToastAction";
import {selectRecipe} from "../../actions/RecipeSelectActions";
import update from "react-addons-update";
import {showAlert} from "../../actions/AlertAction";

const c = require("../../constants");

class RecipeStockUpdate extends Component {
    constructor() {
        super();

        this.state = {
            quantity: 0,
            quantity_error: false,
            sending: false,
            recipe:{}
        };
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.recipe_select) {
            this.setState({recipe: nextProps.recipe_select});
        }
    }

    handleClose = () => {
        this.props.openModalProductStockUpdate({
            is_open: false,
            is_add: true,
            recipe: null,
            stock: null
        });
        this.setState({quantity:0, sending:false, quantity_error:false});
    };

     handleSubmit = (event) => {
        event.preventDefault();
        if (this.state.quantity <= 0 || (this.state.quantity > this.props.modal.stock.total && !this.props.modal.is_add)) {
            this.setState({quantity_error: true})
        } else {
            this.setState({sending: true});
            let data = {
                recipe: this.props.modal.product.id,
                branch_office: this.props.modal.stock.id,
                quantity: this.props.modal.is_add ? this.state.quantity:(-1*this.state.quantity),
                track_type: this.props.modal.is_add ? 3:5
            };
            RecipeStockData.update(data, (res) => {
                this.setState({sending: false});
                if (res.update) {
                    let stock = this.props.modal.stock;
                    stock.total += data.quantity;
                    let recipe = update(this.state.recipe, {
                            count_stock: {
                                $set: stock.total
                            }
                    });
                    this.props.selectRecipe(null);
                    this.props.selectRecipe(recipe);
                    this.props.updateRecipeStock(stock);
                    this.props.showAlert({
                        show:true,
                        html:true,
                        type:'success',
                        message:renderToStaticMarkup(
                            this.ingredients_used(res.ingredients_used)
                        )
                    });
                    this.save_to_pdf(res.ingredients_used);
                    this.handleClose();
                } else {
                    this.props.showToast({type:'error', message:res.message});
                }
            }).catch((err)=>{
                this.props.showToast({type:'error', message:'No hay conexión a internet!'});
            });
        }
    };

    ingredients_used(data){
        let text = !data.is_add ? 'Ingredientes Agregados\n':'Ingredientes Utilizados\n'
        data.ingredients_used.map((ingredient_used) => text += `${ingredient_used.quantity} ${ingredient_used.unit} x ${ingredient_used.ingredient}\n`)
        return <div>
            <Header sub>Sucursal: {this.props.modal.stock.name}</Header>
            <span>Porciones: {this.state.quantity}</span>
            <Table unstackable>
                <Table.Header>
                    <Table.Row>
                        <Table.HeaderCell>Cantidad</Table.HeaderCell>
                        <Table.HeaderCell>Unidad</Table.HeaderCell>
                        <Table.HeaderCell>Ingrediente</Table.HeaderCell>
                    </Table.Row>
                </Table.Header>

                <Table.Body>
                    {data.ingredients_used.map((ingredient_used) => <Table.Row key={ingredient_used.ingredient}>
                        <Table.Cell>{Math.round((ingredient_used.quantity + Number.EPSILON) * 100) / 100}</Table.Cell>
                        <Table.Cell>{c.UNITS.find((unit) => unit.key===ingredient_used.unit).text}</Table.Cell>
                        <Table.Cell>{ingredient_used.ingredient}</Table.Cell>
                    </Table.Row>)}
                </Table.Body>
            </Table>
        </div>
    }

    handleTotalChange = (event) => {
        if (event.target.value.trim() !== '') {
            let quantity = parseInt(event.target.value, 0);
            if (quantity >= 0) {
                this.setState({quantity});
                this.setState({quantity_error: false})
            } else {
                this.setState({quantity_error: true})
            }
        } else {
            this.setState({quantity_error: true, quantity: ''})
        }
    };

    save_to_pdf(data) {
        const doc = new jsPDF();
        let text = `Receta - ${this.props.modal.product.name}\n\n`
        text += `Sucursal: ${this.props.modal.stock.name}\n`
        text += `Porciones: ${this.state.quantity}\n\n`
        text += !data.is_add ? 'Ingredientes Agregados\n\n':'Ingredientes Utilizados\n\n'

        data.ingredients_used.map((ingredient_used) => text += `${Math.round((ingredient_used.quantity + Number.EPSILON) * 100) / 100} ${c.UNITS.find((unit) => unit.key===ingredient_used.unit).abbr} - ${ingredient_used.ingredient}\n`)
        doc.text(text, 10, 10);
        doc.save(`informe_receta_${this.props.modal.product.name}.pdf`);
    }

    render() {
        return (
            <Modal size='tiny' dimmer='inverted' open={this.props.modal.is_open} onClose={this.handleClose}>
                <Modal.Header>
                    {`${this.props.modal.product ? this.props.modal.product.name:''} (${this.props.modal.stock ? this.props.modal.stock.total:0} disponibles) - ${this.props.modal.is_add? 'Actualizar Inventario':'Dar de Baja'}`}
                </Modal.Header>
                <Modal.Content>
                    <Modal.Description>
                        <Form onSubmit={this.handleSubmit}>
                            <Form.Input label={`Porciones a ${this.props.modal.is_add ? 'Agregar':'Dar de Baja'}:`} min={0} type='number' value={this.state.quantity}
                                        onChange={this.handleTotalChange} error={this.state.quantity_error}/>
                        </Form>
                    </Modal.Description>
                </Modal.Content>
                <Modal.Actions>
                    <Button onClick={this.handleClose} icon='x' labelPosition='left' content="Cancelar"/>
                    <Button primary loading={this.state.sending} disabled={this.state.sending} icon='check'
                            labelPosition='left' content={`${this.props.modal.is_add ? 'Actualizar':'Dar de Baja'}`} onClick={this.handleSubmit}/>
                </Modal.Actions>
            </Modal>
        );
    }
}

function mapStateToProps(state) {
    return {
        modal: state.get('product_stock_update_modal'),
        recipe_dialog: state.get('recipe_dialog'),
        recipe_select: state.get('recipe_select'),
    };
}

function mapDispatchToProps(dispatch) {
    return {
        openModalProductStockUpdate(modal){
            dispatch(openModalProductStockUpdate(modal))
        },
        showAlert(alert){
            dispatch(showAlert(alert))
        },
        showToast(alert){
            dispatch(showToast(alert))
        },
        updateRecipeStock(product_stock){
            dispatch(updateRecipeStock(product_stock))
        },
        selectRecipe(data){
            dispatch(selectRecipe(data))
        }
    }
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(RecipeStockUpdate);



// WEBPACK FOOTER //
// ./src/components/inventories/RecipeStockUpdate.js